import { AppRoutes } from '@/i18n/constants';
import { Link } from '@/i18n/routing';

export const LinkToMissionPageWrapper = ({ enabled, children }: { enabled?: boolean; children: React.ReactNode }) => {
  if (!enabled) {
    return <>{children}</>;
  }

  return (
    <Link href={AppRoutes.gamificationMissions} className="contents">
      {children}
    </Link>
  );
};
